var _rect, _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 4.5,
    fill: "#CD2E3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,4.5a4.5,4.5,0,0,0,0,9,2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,1,0-4.5z",
    fill: "#003478"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.8,
    width: 4,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.1,
    width: 1.5,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 5.1,
    width: 1.5,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6.4,
    width: 4,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 3.8,
    width: 4,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 5.1,
    width: 4,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6.4,
    width: 4,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11.5,
    width: 4,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12.8,
    width: 1.5,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 12.8,
    width: 1.5,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14.1,
    width: 4,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11.5,
    width: 1.5,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 11.5,
    width: 1.5,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12.8,
    width: 1.5,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 12.8,
    width: 1.5,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14.1,
    width: 4,
    height: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.d63c19fd45aed17f78960ddc11473d6d.svg";
export { ForwardRef as ReactComponent };